(function () {
  'use strict';

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getProductHandles() {
    var handles = {};
    var options = document.querySelectorAll('#bta-product-select option[value]');

    options.forEach(function (option) {
      var title = normalizeText(option.textContent);
      var handle = String(option.value || '').trim();
      if (title && handle) handles[title] = handle;
    });

    return handles;
  }

  function removePublicFilters() {
    var filterIds = ['product-filter-block', 'location-filter-block', 'bta-variant-select-wrap'];

    filterIds.forEach(function (id) {
      var filter = document.getElementById(id);
      if (!filter) return;
      filter.hidden = true;
      filter.setAttribute('aria-hidden', 'true');
    });
  }

  function removeStaleOptions() {
    var productOptions = document.querySelectorAll('#bta-product-select option');
    productOptions.forEach(function (option) {
      if (normalizeText(option.textContent).indexOf('computer disassembly workshop') !== -1) {
        option.remove();
      }
    });

    var locationOptions = document.querySelectorAll('#bta-location-select option');
    locationOptions.forEach(function (option) {
      if (normalizeText(option.textContent) === 'the makers mark') option.remove();
    });
  }

  function linkSoldOutWorkshops(calendar, productHandles) {
    var soldOutEvents = calendar.querySelectorAll('a.booked-out:not([href])');

    soldOutEvents.forEach(function (event) {
      var titleElement = event.querySelector('.fc-title');
      var title = titleElement ? titleElement.textContent.trim() : '';
      var handle = productHandles[normalizeText(title)];
      if (!handle) return;

      event.setAttribute('href', '/products/' + encodeURIComponent(handle));
      event.setAttribute('aria-label', title + '. Sold out. View workshop details and waitlist.');
      event.setAttribute('title', 'View workshop details and waitlist');
    });
  }

  function observeCalendar(calendar, shell) {
    if (calendar.getAttribute('data-nmi-calendar-observed') === 'true') return;

    calendar.setAttribute('data-nmi-calendar-observed', 'true');
    var updatePending = false;
    var observer = new MutationObserver(function () {
      if (updatePending) return;
      updatePending = true;

      window.requestAnimationFrame(function () {
        updatePending = false;
        linkSoldOutWorkshops(calendar, getProductHandles());
      });
    });

    observer.observe(shell || calendar, { childList: true, subtree: true });
  }

  function prepareCalendarPage() {
    var calendar = document.getElementById('bta-calendar');
    if (!calendar) return false;

    var shell = calendar.parentElement;
    while (
      shell &&
      shell.id !== 'MainContent' &&
      (!shell.querySelector('#bta-product-select') || !shell.querySelector('#bta-location-select'))
    ) {
      shell = shell.parentElement;
    }

    if (!shell || shell.id === 'MainContent') shell = calendar.parentElement;
    if (shell) shell.classList.add('nmi-calendar-shell');

    var headings = document.querySelectorAll('#MainContent h1, #MainContent h2, #MainContent h3, #MainContent h4');
    headings.forEach(function (heading) {
      if (heading.textContent.trim().toLowerCase() === 'events calendar') {
        heading.classList.add('nmi-calendar-heading');
        heading.textContent = 'UPCOMING WORKSHOPS';
      }
    });

    var loading = document.getElementById('bta-loading');
    if (loading) {
      loading.setAttribute('role', 'status');
      loading.setAttribute('aria-live', 'polite');
      loading.setAttribute('aria-label', 'Loading upcoming workshops');
    }

    var productHandles = getProductHandles();
    removePublicFilters();
    removeStaleOptions();
    linkSoldOutWorkshops(calendar, productHandles);
    observeCalendar(calendar, shell);

    return true;
  }

  function initialize() {
    if (prepareCalendarPage()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (prepareCalendarPage() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
